export default "__VITE_ASSET__84d$bm0v__"